import { axiosInstanceWithoutLoader } from "@/use/utilities/axios/app/axios-instance-without-loader";

export async function fetchByDepartment(departmentSlug) {
  const axios = axiosInstanceWithoutLoader().primoLab;

  try {
    const response = await axios.get(`/stuck-work-warnings/${departmentSlug}`);
    return response.data.data ?? null;
  } catch {
    return null;
  }
}
